
import React from "react";
import CalculatorPage from "@/components/calculator/CalculatorPage";
import PressureAdvanceCalculatorCard from "@/components/calculator/pressure-advance/PressureAdvanceCalculatorCard";

const PressureAdvanceCalculator = () => {
  return (
    <CalculatorPage
      title="Pressure Advance Calculator - 3D Printer Pressure Advance Tuning Tool"
      mobileTitle="Pressure Advance Calc"
      description="Calculate optimal pressure advance settings for 3D printing. Mobile-first pressure advance calculator with slicer integration."
      keywords="pressure advance calculator, 3D printing calibration, printer tuning, linear advance"
      canonicalUrl="https://3dphub.net/tools/pressure-advance"
      footerText="3DP Hub | Pressure Advance Calibration Calculator"
      calculatorTitle="Pressure Advance Calculator"
      calculatorDescription="Calculate optimal pressure advance settings for your 3D printer"
    >
      <PressureAdvanceCalculatorCard />
    </CalculatorPage>
  );
};

export default PressureAdvanceCalculator;
